import NPSQuestionnaire from "../Components/NPSQuestionnaire/NPSQuestionnaire"

const NPSQuestionnairePage = () => {
    return (
        <>
            <NPSQuestionnaire />
        </>
    )
}

export default NPSQuestionnairePage